import { render, staticRenderFns } from "./AdminReportingView.vue?vue&type=template&id=2749f8a4&scoped=true"
import script from "./AdminReportingView.vue?vue&type=script&lang=js"
export * from "./AdminReportingView.vue?vue&type=script&lang=js"
import style0 from "./AdminReportingView.vue?vue&type=style&index=0&id=2749f8a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2749f8a4",
  null
  
)

export default component.exports